import { useState, useEffect } from 'react'
import SuscripcionCard from '../components/SuscripcionCard'
import FormularioSuscripcion from '../components/FormularioSuscripcion'
import CuentaCard from '../components/CuentaCard'
import FormularioCuenta from '../components/FormularioCuenta'
import HeirCard from '../components/HeirCard'
import FormularioHeredero from '../components/FormularioHeredero'
import MascotaCard from '../components/MascotaCard'
import FormularioMascota from '../components/FormularioMascota'

const API = 'https://legado-digital-production.up.railway.app'

function Onboarding({ onCompletar, onSaltar }) {
  const [paso, setPaso] = useState(0)

  const pasos = [
    {
      emoji: '👋',
      titulo: 'Bienvenida a ETERN-ME',
      texto: 'En unos minutos tendrás tu información organizada y accesible. Solo necesitas seguir 4 pasos simples.',
      boton: 'Empezar',
    },
    {
      emoji: '🔐',
      titulo: 'Añade tu información importante',
      texto: 'Guarda tus cuentas y suscripciones — Netflix, banco, email, redes sociales. Quien tú elijas sabrá qué existe y cómo gestionarlo.',
      boton: 'Entendido',
    },
    {
      emoji: '👥',
      titulo: "Elige a tu guardián y tu círculo",
      texto: 'Asigna tu guardián — tu persona de máxima confianza — y tu círculo de personas cercanas. Tú decides quién es cada uno y qué puede ver.',
      boton: 'Entendido',
    },
    {
      emoji: '🔔',
      titulo: 'Activa SOS',
      texto: 'Si dejas de responder, alguien sabrá qué hacer. Sin incertidumbre. Sin caos. Sin angustia innecesaria. Tú configuras con qué frecuencia.',
      boton: '¡Empezar!',
    },
  ]

  const pasoActual = pasos[paso]
  const progreso = Math.round((paso / (pasos.length - 1)) * 100)

  return (
    <div style={estilosOnboarding.overlay}>
      <div style={estilosOnboarding.modal}>
        <div style={estilosOnboarding.progreso}>
          <div style={estilosOnboarding.progresoLabel}>Paso {paso + 1} de {pasos.length}</div>
          <div style={estilosOnboarding.barra}>
            <div style={{ ...estilosOnboarding.barraRelleno, width: `${progreso}%` }} />
          </div>
        </div>
        <div style={estilosOnboarding.emoji}>{pasoActual.emoji}</div>
        <h2 style={estilosOnboarding.titulo}>{pasoActual.titulo}</h2>
        <p style={estilosOnboarding.texto}>{pasoActual.texto}</p>
        <div style={estilosOnboarding.botones}>
          <button
            onClick={() => { if (paso < pasos.length - 1) setPaso(paso + 1); else onCompletar() }}
            style={estilosOnboarding.btnPrimario}
          >
            {pasoActual.boton}
          </button>
          {paso === 0 && (
            <button onClick={onSaltar} style={estilosOnboarding.btnSaltar}>Saltar introducción</button>
          )}
        </div>
      </div>
    </div>
  )
}

function ScoreProteccion({ suscripciones, cuentas, herederos, mascotas, mensajes, switchActivo, tienePerfil, tieneVoluntades, onIrAPestana, onIrASwitch, onIrAMensajes, onIrAPerfil }) {
  const items = [
  { label: 'Servicios guardados', hecho: suscripciones.length > 0 || cuentas.length > 0, accion: () => onIrAPestana('miscuentas'), hint: 'Añade tus cuentas y suscripciones' },
  { label: 'Guardián asignado', hecho: herederos.some(h => h.rol === 'confirmer'), accion: () => onIrAPestana('mispersonas'), hint: 'Añade tu guardián de confianza' },
  { label: 'Círculo designado', hecho: herederos.some(h => h.rol === 'heir'), accion: () => onIrAPestana('mispersonas'), hint: 'Añade personas a tu círculo' },
  { label: 'Estoy bien — alerta activa', hecho: switchActivo, accion: onIrASwitch, hint: 'Activa el sistema Estoy bien' },
  { label: 'Instrucciones para mascotas', hecho: mascotas.length > 0, accion: () => onIrAPestana('mascotas'), hint: 'Añade instrucciones para tus mascotas' },
  { label: 'Carta personal creada', hecho: mensajes.filter(m => m.tipo === 'cartas').length > 0, accion: onIrAMensajes, hint: 'Escribe tu primera carta' },
  { label: 'Mi historia iniciada', hecho: mensajes.filter(m => m.tipo === 'mihistoria').length > 0, accion: () => onIrAPestana('mihistoria'), hint: 'Añade tu primera historia' },
  { label: 'Perfil personal completado', hecho: tienePerfil, accion: onIrAPerfil, hint: 'Completa tu perfil' },
  { label: 'Mis deseos guardados', hecho: tieneVoluntades, accion: onIrAPerfil, hint: 'Añade tus deseos' },
  { label: 'SOS configurado', hecho: tienePerfil && herederos.some(h => h.rol === 'confirmer'), accion: () => onIrAPestana('sialgopasa'), hint: 'Configura tu plan de emergencia' },
]

  const completados = items.filter(i => i.hecho).length
  const porcentaje = Math.round((completados / items.length) * 100)
  const color = porcentaje >= 80 ? '#5C6B3A' : porcentaje >= 50 ? '#8B6F47' : '#8B2E0F'

  return (
    <div style={estilosScore.card}>
      <div style={estilosScore.header}>
        <div>
          <div style={estilosScore.titulo}>Tu estado — qué tienes listo</div>
          <div style={{ ...estilosScore.porcentaje, color }}>{porcentaje}%</div>
        </div>
        <div style={estilosScore.circulo}>
          <svg viewBox="0 0 36 36" style={{ width: '80px', height: '80px', transform: 'rotate(-90deg)' }}>
            <circle cx="18" cy="18" r="15.9" fill="none" stroke="#E8E0D5" strokeWidth="3" />
            <circle cx="18" cy="18" r="15.9" fill="none" stroke={color} strokeWidth="3"
              strokeDasharray={`${porcentaje} 100`} strokeLinecap="round" />
          </svg>
          <div style={{ ...estilosScore.circPct, color }}>{porcentaje}%</div>
        </div>
      </div>
      <div style={estilosScore.barra}>
        <div style={{ ...estilosScore.barraRelleno, width: `${porcentaje}%`, backgroundColor: color }} />
      </div>
      <div style={estilosScore.items}>
        {items.map((item, i) => (
          <div key={i} style={estilosScore.item} onClick={!item.hecho ? item.accion : undefined}>
            <span style={{ ...estilosScore.itemIcon, color: item.hecho ? '#5C6B3A' : '#C4A882' }}>
              {item.hecho ? '✓' : '○'}
            </span>
            <span style={{ ...estilosScore.itemLabel, color: item.hecho ? '#2C1810' : '#8B6F47' }}>
              {item.hecho ? item.label : item.hint}
            </span>
            {!item.hecho && <span style={estilosScore.itemBtn}>Añadir →</span>}
          </div>
        ))}
      </div>
      {porcentaje === 100 && (
        <div style={estilosScore.completo}>🎉 ¡Todo en orden! Tu información está protegida y accesible.</div>
      )}
    </div>
  )
}

function Dashboard({ userId, paginaActiva, onCambiarPagina, onIrASwitch, onIrAMensajes, onIrAPerfil }) {  const [suscripciones, setSuscripciones] = useState([])
  const [cuentas, setCuentas] = useState([])
  const [herederos, setHerederos] = useState([])
  const [mascotas, setMascotas] = useState([])
  const [mensajes, setMensajes] = useState([])
  const [tienePerfil, setTienePerfil] = useState(false)
  const [tieneVoluntades, setTieneVoluntades] = useState(false)
  const [switchActivo, setSwitchActivo] = useState(false)
  const [cargando, setCargando] = useState(true)
  const [error, setError] = useState('')
  const [mostrarOnboarding, setMostrarOnboarding] = useState(false)

  useEffect(() => {
    const visto = localStorage.getItem(`onboarding_${userId}`)
    if (!visto) setMostrarOnboarding(true)
    cargarDatos()
  }, [userId])

  async function cargarDatos() {
    setCargando(true)
    try {
      const [resSubs, resCuentas, resHerederos, resMascotas, resSwitch, resMensajes, resPerfil, resVoluntades] = await Promise.all([
        fetch(`${API}/api/subscriptions?userId=${userId}`),
        fetch(`${API}/api/accounts?userId=${userId}`),
        fetch(`${API}/api/heirs?userId=${userId}`),
        fetch(`${API}/api/mascotas?userId=${userId}`),
        fetch(`${API}/api/switch/${userId}`),
        fetch(`${API}/api/messages?userId=${userId}`),
        fetch(`${API}/api/perfil?userId=${userId}`),
        fetch(`${API}/api/voluntades?userId=${userId}`),
      ])
      const [dataSubs, dataCuentas, dataHerederos, dataMascotas, dataSwitch, dataMensajes, dataPerfil, dataVoluntades] = await Promise.all([
        resSubs.json(), resCuentas.json(), resHerederos.json(), resMascotas.json(), resSwitch.json(), resMensajes.json(), resPerfil.json(), resVoluntades.json()
      ])
      if (dataSubs.ok) setSuscripciones(dataSubs.datos)
      if (dataCuentas.ok) setCuentas(dataCuentas.datos)
      if (dataHerederos.ok) setHerederos(dataHerederos.datos)
      if (dataMascotas.ok) setMascotas(dataMascotas.datos)
      if (dataSwitch.ok) setSwitchActivo(dataSwitch.datos.switch_activo)
      if (dataMensajes.ok) setMensajes(dataMensajes.datos)
      if (dataPerfil.ok && dataPerfil.datos) setTienePerfil(!!dataPerfil.datos.nombre_completo)
      if (dataVoluntades.ok && dataVoluntades.datos) setTieneVoluntades(!!dataVoluntades.datos.tipo_entierro || !!dataVoluntades.datos.donacion_organos)
    } catch {
      setError('No se pudo conectar con el servidor')
    } finally {
      setCargando(false)
    }
  }

  function completarOnboarding() {
    localStorage.setItem(`onboarding_${userId}`, 'true')
    setMostrarOnboarding(false)
  }

  function handleNuevaSuscripcion(nueva) { setSuscripciones(prev => [nueva, ...prev]) }
  async function handleEliminarSuscripcion(id) {
    await fetch(`${API}/api/subscriptions/${id}`, { method: 'DELETE' })
    setSuscripciones(prev => prev.filter(s => s.id !== id))
  }
  function handleNuevaCuenta(nueva) { setCuentas(prev => [nueva, ...prev]) }
  async function handleEliminarCuenta(id) {
    await fetch(`${API}/api/accounts/${id}`, { method: 'DELETE' })
    setCuentas(prev => prev.filter(c => c.id !== id))
  }
  function handleNuevoHeredero(nuevo) { setHerederos(prev => [...prev, nuevo]) }
  async function handleEliminarHeredero(id) {
    await fetch(`${API}/api/heirs/${id}`, { method: 'DELETE' })
    setHerederos(prev => prev.filter(h => h.id !== id))
  }
  function handleNuevaMascota(nueva) { setMascotas(prev => [...prev, nueva]) }
  async function handleEliminarMascota(id) {
    await fetch(`${API}/api/mascotas/${id}`, { method: 'DELETE' })
    setMascotas(prev => prev.filter(m => m.id !== id))
  }

  return (
    <div style={estilos.pagina} className="pagina-contenido">
      {mostrarOnboarding && (
        <Onboarding onCompletar={completarOnboarding} onSaltar={completarOnboarding} />
      )}
      <div style={estilos.contenido}>
        {cargando && <p style={estilos.mensaje}>Cargando...</p>}
        {error && <div style={estilos.error}>{error}</div>}

        {!cargando && paginaActiva === 'estado' && (
          <ScoreProteccion
            suscripciones={suscripciones}
            cuentas={cuentas}
            herederos={herederos}
            mascotas={mascotas}
            mensajes={mensajes}
            switchActivo={switchActivo}
            tienePerfil={tienePerfil}
            tieneVoluntades={tieneVoluntades}
            onIrAPestana={onCambiarPagina}
            onIrASwitch={onIrASwitch}
            onIrAMensajes={onIrAMensajes}
            onIrAPerfil={onIrAPerfil}
          />
        )}

       {!cargando && paginaActiva === 'miscuentas' && (
  <>
    <h2 style={estilos.seccionTitulo}>Mis cuentas</h2>
    <p style={{ fontSize: '14px', color: '#8B6F47', lineHeight: '1.7', marginBottom: '24px' }}>
      Guarda aquí tus servicios digitales en dos categorías:
      <strong style={{ color: '#2C1810' }}> Suscripciones</strong> — servicios que pagas
      periódicamente (Netflix, Spotify, gimnasio, seguros...) y
      <strong style={{ color: '#2C1810' }}> Cuentas digitales</strong> — accesos importantes
      (email, banco, redes sociales, trabajo...). Tu círculo sabrá qué existe y cómo gestionarlo.
    </p>
    <FormularioSuscripcion onSuscripcionCreada={handleNuevaSuscripcion} userId={userId} />
    {suscripciones.length === 0
      ? <p style={estilos.mensaje}>No tienes suscripciones. Añade la primera arriba.</p>
      : suscripciones.map(s => <SuscripcionCard key={s.id} suscripcion={s} onEliminar={handleEliminarSuscripcion} />)}
    <FormularioCuenta onCuentaCreada={handleNuevaCuenta} userId={userId} />
    {cuentas.length === 0
      ? <p style={estilos.mensaje}>No tienes servicios guardados. Añade el primero arriba.</p>
      : cuentas.map(c => <CuentaCard key={c.id} cuenta={c} onEliminar={handleEliminarCuenta} />)}
  </>
)}

        {!cargando && paginaActiva === 'mispersonas' && (
  <>
    <h2 style={estilos.seccionTitulo}>Mis personas</h2>
    <p style={{ fontSize: '14px', color: '#8B6F47', lineHeight: '1.7', marginBottom: '16px' }}>
      Las personas que estarán ahí si algo te pasa. Hay dos roles distintos:
    </p>
    <div style={{
      display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px',
      marginBottom: '24px'
    }}>
      <div style={{
        backgroundColor: '#FFFFFF', border: '2px solid #2C1810',
        borderRadius: '12px', padding: '16px'
      }}>
        <div style={{ fontSize: '15px', fontWeight: '700', color: '#2C1810', marginBottom: '6px' }}>
          🛡️ Mi guardián
        </div>
        <div style={{ fontSize: '13px', color: '#5C4033', lineHeight: '1.6' }}>
          Tu persona de máxima confianza. Recibe el aviso del sistema de alerta
          y activa el acceso al resto de tu círculo cuando sea necesario.
          Solo puedes tener uno.
        </div>
      </div>
      <div style={{
        backgroundColor: '#FFFFFF', border: '1px solid #E8E0D5',
        borderRadius: '12px', padding: '16px'
      }}>
        <div style={{ fontSize: '15px', fontWeight: '700', color: '#2C1810', marginBottom: '6px' }}>
          👥 Mi círculo
        </div>
        <div style={{ fontSize: '13px', color: '#5C4033', lineHeight: '1.6' }}>
          Personas que podrán acceder a partes de tu información cuando
          tu guardián lo autorice. Puedes añadir tantas como quieras
          con diferentes niveles de acceso.
        </div>
      </div>
    </div>
    <FormularioHeredero onHerederoCreado={handleNuevoHeredero} userId={userId} />
    {herederos.length === 0
      ? <p style={estilos.mensaje}>No has añadido nadie todavía. Añade tu guardián primero.</p>
      : herederos.map(h => <HeirCard key={h.id} heredero={h} onEliminar={handleEliminarHeredero} />)}
  </>
)}

        {!cargando && paginaActiva === 'mascotas' && (
          <>
            <FormularioMascota onMascotaCreada={handleNuevaMascota} userId={userId} />
            {mascotas.length === 0
              ? <p style={estilos.mensaje}>No has añadido mascotas. Deja instrucciones para quien las cuide.</p>
              : mascotas.map(m => <MascotaCard key={m.id} mascota={m} onEliminar={handleEliminarMascota} />)}
          </>
        )}
      </div>
    </div>
  )
}

const estilosOnboarding = {
  overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(44,24,16,0.7)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' },
  modal: { backgroundColor: '#FAF8F5', borderRadius: '16px', padding: '36px 32px', maxWidth: '480px', width: '100%', textAlign: 'center' },
  progreso: { marginBottom: '28px' },
  progresoLabel: { fontSize: '12px', color: '#8B6F47', marginBottom: '8px' },
  barra: { height: '4px', backgroundColor: '#E8E0D5', borderRadius: '2px', overflow: 'hidden' },
  barraRelleno: { height: '4px', backgroundColor: '#2C1810', borderRadius: '2px', transition: 'width 0.4s ease' },
  emoji: { fontSize: '48px', marginBottom: '16px' },
  titulo: { fontSize: '22px', fontWeight: '800', color: '#2C1810', marginBottom: '12px', letterSpacing: '-0.5px' },
  texto: { fontSize: '15px', color: '#5C4033', lineHeight: '1.7', marginBottom: '28px' },
  botones: { display: 'flex', flexDirection: 'column', gap: '10px' },
  btnPrimario: { backgroundColor: '#2C1810', color: '#FAF8F5', border: 'none', padding: '14px', borderRadius: '10px', fontSize: '15px', fontWeight: '600', cursor: 'pointer' },
  btnSaltar: { backgroundColor: 'transparent', color: '#8B6F47', border: 'none', padding: '8px', fontSize: '13px', cursor: 'pointer' },
}

const estilosScore = {
  card: { backgroundColor: '#FFFFFF', borderRadius: '12px', padding: '24px', border: '1px solid #E8E0D5', marginBottom: '20px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' },
  titulo: { fontSize: '13px', color: '#8B6F47', marginBottom: '4px', fontWeight: '500' },
  porcentaje: { fontSize: '36px', fontWeight: '800', letterSpacing: '-1px' },
  circulo: { position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  circPct: { position: 'absolute', fontSize: '14px', fontWeight: '700' },
  barra: { height: '6px', backgroundColor: '#E8E0D5', borderRadius: '3px', overflow: 'hidden', marginBottom: '20px' },
  barraRelleno: { height: '6px', borderRadius: '3px', transition: 'width 0.5s ease' },
  items: { display: 'flex', flexDirection: 'column', gap: '10px' },
  item: { display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', padding: '6px 0' },
  itemIcon: { fontSize: '16px', fontWeight: '700', width: '20px', flexShrink: 0 },
  itemLabel: { fontSize: '14px', flex: 1 },
  itemBtn: { fontSize: '12px', color: '#8B6F47', fontWeight: '500' },
  completo: { marginTop: '16px', backgroundColor: '#F0F4E8', color: '#3D4D1F', padding: '12px 16px', borderRadius: '8px', fontSize: '14px', textAlign: 'center', border: '1px solid #C8D5A0' },
}

const estilos = {
  pagina: { minHeight: 'calc(100vh - 64px)', backgroundColor: '#FAF8F5', padding: '32px 16px', scrollMarginTop: '56px' },
  contenido: { maxWidth: '740px', margin: '0 auto' },
  mensaje: { textAlign: 'center', color: '#C4A882', padding: '40px 24px', backgroundColor: '#FFFFFF', borderRadius: '12px', border: '1px solid #E8E0D5', fontSize: '14px' },
  error: { backgroundColor: '#FDF0EC', color: '#8B2E0F', padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', border: '1px solid #F5C9B8', fontSize: '14px' },
seccionTitulo: { fontSize: '20px', fontWeight: '700', color: '#2C1810', marginBottom: '20px', letterSpacing: '-0.3px' }
}
export default Dashboard